import { defineStore } from 'pinia';
import { authService } from '../services/authService';
import { parseJwtToken } from '../utils/jwtHelper';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('userToken') || '',
    userInfo: {},
    isLoggedIn: false,
    loading: false,
    error: null,
    signature: null,
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token && state.isLoggedIn,
    userToken: (state) => state.token,
    getUserInfo: (state) => state.userInfo,
    avatarUrl: (state) => state.userInfo.avatarUrl || '',
    nickname: (state) => state.userInfo.nickname || state.userInfo.memberAccount || '用户',
    getSignature: (state) => state.signature,
  },
  
  actions: {
    // 设置Token并解析用户信息
    setToken(token) {
      if (!token) {
        this.clearAuth();
        return;
      }
      
      this.token = token;
      this.isLoggedIn = true;
      localStorage.setItem('userToken', token);
      
      // 解析JWT Token获取用户信息
      const userInfo = parseJwtToken(token);
      this.setUserInfo(userInfo);
    },
    
    // 设置用户信息
    setUserInfo(info) {
      this.userInfo = info;
    },
    
    // 从localStorage恢复用户会话
    loadUserFromStorage() {
      const token = localStorage.getItem('userToken');
      if (token) {
        this.token = token;
        const userInfo = parseJwtToken(token);
        this.userInfo = userInfo;
        return true;
      }
      return false;
    },
    
    // 验证Token有效性
    async verifyToken() {
      if (!this.token) return false;
      
      this.loading = true;
      this.error = null;
      
      try {
        const isValid = await authService.verifyToken(this.token);
        this.isLoggedIn = isValid;
        
        if (!isValid) {
          this.clearAuth();
        }
        
        return isValid;
      } catch (error) {
        console.error('Token验证失败:', error);
        this.error = error.message || '身份验证失败';
        this.clearAuth();
        return false;
      } finally {
        this.loading = false;
      }
    },
    
    // 处理微信登录回调
    handleWxLoginCallback(urlToken) {
      if (urlToken) {
        this.setToken(urlToken);
        return true;
      }
      return false;
    },
    
    // 退出登录
    logout() {
      this.clearAuth();
    },
    
    // 清除认证信息
    clearAuth() {
      this.token = '';
      this.userInfo = {};
      this.isLoggedIn = false;
      localStorage.removeItem('userToken');
    },

    /**
     * 获取用户签名
     * @param {string} url 当前页面URL
     * @returns {Promise<Object>} 签名信息
     */
    async fetchSignature(url) {
      if (!this.token) return null;
      
      try {
        const signature = await authService.getSignature(this.token, url);
        if (signature) {
          this.signature = signature;
        }
        return signature;
      } catch (error) {
        console.error('获取签名失败:', error);
        return null;
      }
    },
  }
}); 